import React from 'react';

import TwoColmunsFieldsRow from '../TwoColmunsFieldsRow';
import CustomerEmailField from './CustomerEmailField';
import CustomerPhoneField from './CustomerPhoneField';

function CustomerContactFields() {
  return (
    <TwoColmunsFieldsRow gridTemplateColumns={{ md: '1fr', lg: '1fr 1fr' }}>
      <CustomerEmailField />
      <CustomerPhoneField />
    </TwoColmunsFieldsRow>
  );
}

export default CustomerContactFields;
